import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Modal from "@mui/material/Modal";
import { Fragment, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Fade,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Radio from "@mui/material/Radio";
import eyeSlash from "../Images/eye-slash.svg";
import eye from "../Images/eye.svg";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import noDataImage from "../Images/No_data_cuate_1.svg";
import Integrations from "../DashBoard/Integrationsdummy";
import UpdateProfile from "../DashBoard/UpdateProfile";
import Billing from "../DashBoard/Billing";
import TrackSettings from "../DashBoard/TrackSettings";
import ApiScreen from "../DashBoard/ApiScreen";
import Integration from "../DashBoard/Integration";
import { useHistory } from "react-router-dom";
import DoNotEmailLists from "../DashBoard/DoNotEmailLists";
import MyTeam from "../DashBoard/MyTeam";
import Transactions from "../DashBoard/Transactions";
import SearchSettings from "../DashBoard/SearchSettings";
import Notifications from "./../DashBoard/Notifications";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Backdrop from "@mui/material/Backdrop";
import Loader from "../Loader";
import nodata from "../Images/nothingfound.svg";
import hostinger from "../Images/hostinger 2.svg";
import amazon1 from "../Images/amazon 1.svg";
import ses1 from "../Images/SES 1.svg";
import s163 from "../Images/163.svg";
import alliyon from "../Images/aliyun 1.svg";
import locaWeb from "../Images/locaweb 1.svg";
import ionos1 from "../Images/lonos 1.svg";
import sendGrid from "../Images/sendgrid 1.svg";
import send2 from "../Images/send-2.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateAccount from "../DashBoard/CreateAccount";
import ApplyPromoCode from "../DashBoard/ApplyPromoCode";
import SignatureBuilder from "../DashBoard/SignatureBuilder";
import SpfGenerator from "../DashBoard/SpfGenerator";
const chartOptions = {
  chart: {
    type: "areaspline",
    height: 250,
  },
  title: {
    text: " ",
    align: "left",
  },
  legend: {
    enabled: false,
  },
  xAxis: {
    labels: {
      enabled: false,
    },
    lineWidth: 0,
    tickWidth: 0,
    title: {
      text: "Revenue",
      color: "#000000",
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "Source Sans 3",
      fontStyle: "normal",
    },
  },
  yAxis: {
    title: {
      text: "Deliverability",
      color: "#000000",
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "Source Sans 3",
      fontStyle: "normal",
    },
    labels: {
      enabled: false, // Hide the y-axis labels
    },
    gridLineWidth: 1, // Thickness of the grid lines
    gridLineColor: "red", // Color of the grid lines
    gridLineDashStyle: "Dash",
  },
  tooltip: {
    shared: true,
    headerFormat: "<b>Deliverability of {point.x}</b><br>",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      pointStart: 20,
    },
    areaspline: {
      fillOpacity: 0.7,
      lineColor: "red",
      color: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, "rgba(83, 216, 106, 1)"], // Start color (fully opaque)
          [1, "rgba(83, 216, 106, 0)"], // End color (fully transparent)
        ],
      },
      marker: false,
      lineWidth: 3,
    },
  },
  series: [
    {
      name: "Revenue",
      data: [20, 25, 30, 35, 40, 50, 55, 60, 65, 70, 80, 90],
    },
  ],
};

const sideBarData = [
  {
    name: "Overview",
    path: "/Accounts",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.1341 9.05829C10.0508 9.04996 9.95078 9.04996 9.85911 9.05829C7.87578 8.99163 6.30078 7.36663 6.30078 5.36663C6.30078 3.32496 7.95078 1.66663 10.0008 1.66663C12.0424 1.66663 13.7008 3.32496 13.7008 5.36663C13.6924 7.36663 12.1174 8.99163 10.1341 9.05829Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.96758 12.1334C3.95091 13.4834 3.95091 15.6834 5.96758 17.025C8.25924 18.5584 12.0176 18.5584 14.3092 17.025C16.3259 15.675 16.3259 13.475 14.3092 12.1334C12.0259 10.6084 8.26758 10.6084 5.96758 12.1334Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.1341 9.05841C10.0508 9.05008 9.95078 9.05008 9.85911 9.05841C7.87578 8.99175 6.30078 7.36675 6.30078 5.36675C6.30078 3.32508 7.95078 1.66675 10.0008 1.66675C12.0424 1.66675 13.7008 3.32508 13.7008 5.36675C13.6924 7.36675 12.1174 8.99175 10.1341 9.05841Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.96758 12.1333C3.95091 13.4833 3.95091 15.6833 5.96758 17.0249C8.25924 18.5583 12.0176 18.5583 14.3092 17.0249C16.3259 15.6749 16.3259 13.4749 14.3092 12.1333C12.0259 10.6083 8.26758 10.6083 5.96758 12.1333Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Billing",
    path: "/Accounts/billing",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.05859 2.08337V12.0584C3.05859 12.875 3.44193 13.65 4.10026 14.1417L8.44192 17.3917C9.36692 18.0834 10.6419 18.0834 11.5669 17.3917L15.9086 14.1417C16.5669 13.65 16.9502 12.875 16.9502 12.0584V2.08337H3.05859Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M1.66602 2.08337H18.3327"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M6.66602 6.66663H13.3327"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66602 10.8334H13.3327"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.05859 2.08325V12.0583C3.05859 12.8749 3.44193 13.6499 4.10026 14.1416L8.44192 17.3916C9.36692 18.0832 10.6419 18.0832 11.5669 17.3916L15.9086 14.1416C16.5669 13.6499 16.9502 12.8749 16.9502 12.0583V2.08325H3.05859Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M1.66602 2.08325H18.3327"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M6.66602 6.66675H13.3327"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66602 10.8333H13.3327"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "My Team",
    path: "/Accounts/team",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.0004 5.96663C14.9504 5.9583 14.8921 5.9583 14.8421 5.96663C13.6921 5.92496 12.7754 4.98329 12.7754 3.81663C12.7754 2.62496 13.7337 1.66663 14.9254 1.66663C16.1171 1.66663 17.0754 2.63329 17.0754 3.81663C17.0671 4.98329 16.1504 5.92496 15.0004 5.96663Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1422 12.0333C15.2839 12.225 16.5422 12.025 17.4255 11.4333C18.6005 10.65 18.6005 9.36664 17.4255 8.58331C16.5339 7.99164 15.2589 7.79163 14.1172 7.99163"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.97344 5.96663C5.02344 5.9583 5.08177 5.9583 5.13177 5.96663C6.28177 5.92496 7.19844 4.98329 7.19844 3.81663C7.19844 2.62496 6.24011 1.66663 5.04844 1.66663C3.85677 1.66663 2.89844 2.63329 2.89844 3.81663C2.90677 4.98329 3.82344 5.92496 4.97344 5.96663Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0004 12.1917C9.95039 12.1834 9.89206 12.1834 9.84206 12.1917C8.69206 12.1501 7.77539 11.2084 7.77539 10.0417C7.77539 8.85006 8.73372 7.89172 9.92539 7.89172C11.1171 7.89172 12.0754 8.85839 12.0754 10.0417C12.0671 11.2084 11.1504 12.1584 10.0004 12.1917Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.57461 14.8167C6.39961 15.6 6.39961 16.8833 7.57461 17.6667C8.90794 18.5583 11.0913 18.5583 12.4246 17.6667C13.5996 16.8833 13.5996 15.6 12.4246 14.8167C11.0996 13.9333 8.90794 13.9333 7.57461 14.8167Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.0004 5.96675C14.9504 5.95842 14.8921 5.95842 14.8421 5.96675C13.6921 5.92508 12.7754 4.98342 12.7754 3.81675C12.7754 2.62508 13.7337 1.66675 14.9254 1.66675C16.1171 1.66675 17.0754 2.63342 17.0754 3.81675C17.0671 4.98342 16.1504 5.92508 15.0004 5.96675Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1422 12.0333C15.2839 12.225 16.5422 12.025 17.4255 11.4333C18.6005 10.65 18.6005 9.36664 17.4255 8.58331C16.5339 7.99164 15.2589 7.79163 14.1172 7.99163"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.97344 5.96675C5.02344 5.95842 5.08177 5.95842 5.13177 5.96675C6.28177 5.92508 7.19844 4.98342 7.19844 3.81675C7.19844 2.62508 6.24011 1.66675 5.04844 1.66675C3.85677 1.66675 2.89844 2.63342 2.89844 3.81675C2.90677 4.98342 3.82344 5.92508 4.97344 5.96675Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0004 12.1916C9.95039 12.1833 9.89206 12.1833 9.84206 12.1916C8.69206 12.1499 7.77539 11.2083 7.77539 10.0416C7.77539 8.84994 8.73372 7.8916 9.92539 7.8916C11.1171 7.8916 12.0754 8.85827 12.0754 10.0416C12.0671 11.2083 11.1504 12.1583 10.0004 12.1916Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.57461 14.8166C6.39961 15.5999 6.39961 16.8832 7.57461 17.6666C8.90794 18.5582 11.0913 18.5582 12.4246 17.6666C13.5996 16.8832 13.5996 15.5999 12.4246 14.8166C11.0996 13.9332 8.90794 13.9332 7.57461 14.8166Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Transactions",
    path: "/Accounts/transactions",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.66602 10.5083H15.8327"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.8327 8.56683V14.5252C15.8077 16.9002 15.1577 17.5002 12.6827 17.5002H4.81604C2.29937 17.5002 1.66602 16.8752 1.66602 14.3918V8.56683C1.66602 6.31683 2.19102 5.59183 4.16602 5.47516C4.36602 5.46683 4.58271 5.4585 4.81604 5.4585H12.6827C15.1993 5.4585 15.8327 6.0835 15.8327 8.56683Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.3327 5.60833V11.4333C18.3327 13.6833 17.8077 14.4083 15.8327 14.525V8.56667C15.8327 6.08333 15.1993 5.45833 12.6827 5.45833H4.81604C4.58271 5.45833 4.36602 5.46667 4.16602 5.475C4.19102 3.1 4.84104 2.5 7.31604 2.5H15.1827C17.6993 2.5 18.3327 3.125 18.3327 5.60833Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.375 14.8418H5.80831"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5918 14.8418H10.4585"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.66602 10.5083H15.8327"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.8327 8.56659V14.5249C15.8077 16.8999 15.1577 17.4999 12.6827 17.4999H4.81604C2.29937 17.4999 1.66602 16.8749 1.66602 14.3916V8.56659C1.66602 6.31658 2.19102 5.59159 4.16602 5.47492C4.36602 5.46659 4.58271 5.45825 4.81604 5.45825H12.6827C15.1993 5.45825 15.8327 6.08325 15.8327 8.56659Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.3327 5.60833V11.4333C18.3327 13.6833 17.8077 14.4083 15.8327 14.525V8.56667C15.8327 6.08333 15.1993 5.45833 12.6827 5.45833H4.81604C4.58271 5.45833 4.36602 5.46667 4.16602 5.475C4.19102 3.1 4.84104 2.5 7.31604 2.5H15.1827C17.6993 2.5 18.3327 3.125 18.3327 5.60833Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.375 14.8416H5.80831"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5918 14.8416H10.4585"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "API",
    path: "/Accounts/API",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M10 13.4607C11.3807 13.4607 12.5 12.3414 12.5 10.9607C12.5 9.57998 11.3807 8.46069 10 8.46069C8.61929 8.46069 7.5 9.57998 7.5 10.9607C7.5 12.3414 8.61929 13.4607 10 13.4607Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.66602 11.6941V10.2274C1.66602 9.36072 2.37435 8.64406 3.24935 8.64406C4.75768 8.64406 5.37435 7.57739 4.61602 6.26906C4.18268 5.51906 4.44102 4.54406 5.19935 4.11072L6.64102 3.28572C7.29935 2.89406 8.14935 3.12739 8.54102 3.78572L8.63268 3.94406C9.38268 5.25239 10.616 5.25239 11.3743 3.94406L11.466 3.78572C11.8577 3.12739 12.7077 2.89406 13.366 3.28572L14.8077 4.11072C15.566 4.54406 15.8243 5.51906 15.391 6.26906C14.6327 7.57739 15.2494 8.64406 16.7577 8.64406C17.6244 8.64406 18.341 9.35239 18.341 10.2274V11.6941C18.341 12.5607 17.6327 13.2774 16.7577 13.2774C15.2494 13.2774 14.6327 14.3441 15.391 15.6524C15.8243 16.4107 15.566 17.3774 14.8077 17.8107L13.366 18.6357C12.7077 19.0274 11.8577 18.7941 11.466 18.1357L11.3743 17.9774C10.6243 16.6691 9.39102 16.6691 8.63268 17.9774L8.54102 18.1357C8.14935 18.7941 7.29935 19.0274 6.64102 18.6357L5.19935 17.8107C4.44102 17.3774 4.18268 16.4024 4.61602 15.6524C5.37435 14.3441 4.75768 13.2774 3.24935 13.2774C2.37435 13.2774 1.66602 12.5607 1.66602 11.6941Z"
          stroke="#868686"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.66602 10.7334V9.2667C1.66602 8.40003 2.37435 7.68336 3.24935 7.68336C4.75768 7.68336 5.37435 6.6167 4.61602 5.30836C4.18268 4.55836 4.44102 3.58336 5.19935 3.15003L6.64102 2.32503C7.29935 1.93336 8.14935 2.1667 8.54102 2.82503L8.63268 2.98336C9.38268 4.2917 10.616 4.2917 11.3743 2.98336L11.466 2.82503C11.8577 2.1667 12.7077 1.93336 13.366 2.32503L14.8077 3.15003C15.566 3.58336 15.8243 4.55836 15.391 5.30836C14.6327 6.6167 15.2494 7.68336 16.7577 7.68336C17.6244 7.68336 18.341 8.3917 18.341 9.2667V10.7334C18.341 11.6 17.6327 12.3167 16.7577 12.3167C15.2494 12.3167 14.6327 13.3834 15.391 14.6917C15.8243 15.45 15.566 16.4167 14.8077 16.85L13.366 17.675C12.7077 18.0667 11.8577 17.8334 11.466 17.175L11.3743 17.0167C10.6243 15.7084 9.39102 15.7084 8.63268 17.0167L8.54102 17.175C8.14935 17.8334 7.29935 18.0667 6.64102 17.675L5.19935 16.85C4.44102 16.4167 4.18268 15.4417 4.61602 14.6917C5.37435 13.3834 4.75768 12.3167 3.24935 12.3167C2.37435 12.3167 1.66602 11.6 1.66602 10.7334Z"
          stroke="#1C485F"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Redeem Promo Code",
    path: "/Accounts/apply-promo-code",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        id="redeem"
      >
        <path fill="none" d="M0 0h24v24H0V0z"></path>
        <path
          fill="#868686"
          d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm10 15H5c-.55 0-1-.45-1-1v-1h16v1c0 .55-.45 1-1 1zm1-5H4V9c0-.55.45-1 1-1h4.08L7.6 10.02c-.33.45-.23 1.08.22 1.4.44.32 1.07.22 1.39-.22L12 7.4l2.79 3.8c.32.44.95.54 1.39.22.45-.32.55-.95.22-1.4L14.92 8H19c.55 0 1 .45 1 1v5z"
        ></path>
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        id="redeem"
      >
        <path fill="none" d="M0 0h24v24H0V0z"></path>
        <path
          fill="#1C485F"
          d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm10 15H5c-.55 0-1-.45-1-1v-1h16v1c0 .55-.45 1-1 1zm1-5H4V9c0-.55.45-1 1-1h4.08L7.6 10.02c-.33.45-.23 1.08.22 1.4.44.32 1.07.22 1.39-.22L12 7.4l2.79 3.8c.32.44.95.54 1.39.22.45-.32.55-.95.22-1.4L14.92 8H19c.55 0 1 .45 1 1v5z"
        ></path>
      </svg>
    ),
  },
  // {
  //   name: "Signature Builder",
  //   path: "/Accounts/signature-builder",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="22"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="#868686"
  //       stroke-width="2"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //       class="feather feather-feather"
  //     >
  //       <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>
  //       <line x1="16" y1="8" x2="2" y2="22"></line>
  //       <line x1="17.5" y1="15" x2="9" y2="15"></line>
  //     </svg>
  //   ),
  //   highlighted: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="22"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="#1C485F"
  //       stroke-width="2"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //       class="feather feather-feather"
  //     >
  //       <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>
  //       <line x1="16" y1="8" x2="2" y2="22"></line>
  //       <line x1="17.5" y1="15" x2="9" y2="15"></line>
  //     </svg>
  //   ),
  // },
  {
    name: "SPF Generator",
    path: "/Accounts/spf-generator",
    svg: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.01413 8.73642L2.26413 5.98642C2.20021 5.92257 2.1495 5.84675 2.11491 5.76329C2.08031 5.67983 2.0625 5.59036 2.0625 5.50002C2.0625 5.40967 2.08031 5.32021 2.11491 5.23674C2.1495 5.15328 2.20021 5.07746 2.26413 5.01361L5.01413 2.26361C5.14314 2.13461 5.3181 2.06213 5.50054 2.06213C5.68298 2.06213 5.85794 2.13461 5.98695 2.26361C6.11595 2.39261 6.18842 2.56758 6.18842 2.75002C6.18842 2.93245 6.11595 3.10742 5.98695 3.23642L3.72249 5.50002L5.98695 7.76361C6.11595 7.89261 6.18842 8.06758 6.18842 8.25002C6.18842 8.43245 6.11595 8.60742 5.98695 8.73642C5.85794 8.86543 5.68298 8.9379 5.50054 8.9379C5.3181 8.9379 5.14314 8.86543 5.01413 8.73642ZM8.45163 8.73642C8.51548 8.80034 8.59131 8.85105 8.67477 8.88565C8.75823 8.92025 8.84769 8.93806 8.93804 8.93806C9.02839 8.93806 9.11785 8.92025 9.20131 8.88565C9.28477 8.85105 9.3606 8.80034 9.42445 8.73642L12.1744 5.98642C12.2384 5.92257 12.2891 5.84675 12.3237 5.76329C12.3583 5.67983 12.3761 5.59036 12.3761 5.50002C12.3761 5.40967 12.3583 5.32021 12.3237 5.23674C12.2891 5.15328 12.2384 5.07746 12.1744 5.01361L9.42445 2.26361C9.29544 2.13461 9.12048 2.06213 8.93804 2.06213C8.7556 2.06213 8.58064 2.13461 8.45163 2.26361C8.32263 2.39261 8.25016 2.56758 8.25016 2.75002C8.25016 2.93245 8.32263 3.10742 8.45163 3.23642L10.7161 5.50002L8.45163 7.76361C8.38771 7.82746 8.337 7.90328 8.30241 7.98674C8.26781 8.07021 8.25 8.15967 8.25 8.25002C8.25 8.34036 8.26781 8.42983 8.30241 8.51329C8.337 8.59675 8.38771 8.67257 8.45163 8.73642ZM17.188 3.43752H15.1255C14.9432 3.43752 14.7683 3.50995 14.6394 3.63888C14.5105 3.76781 14.438 3.94268 14.438 4.12502C14.438 4.30735 14.5105 4.48222 14.6394 4.61115C14.7683 4.74008 14.9432 4.81252 15.1255 4.81252H17.188V17.1875H4.81304V11.6875C4.81304 11.5052 4.74061 11.3303 4.61168 11.2014C4.48275 11.0724 4.30788 11 4.12554 11C3.9432 11 3.76834 11.0724 3.63941 11.2014C3.51047 11.3303 3.43804 11.5052 3.43804 11.6875V17.1875C3.43804 17.5522 3.58291 17.9019 3.84077 18.1598C4.09863 18.4177 4.44837 18.5625 4.81304 18.5625H17.188C17.5527 18.5625 17.9024 18.4177 18.1603 18.1598C18.4182 17.9019 18.563 17.5522 18.563 17.1875V4.81252C18.563 4.44784 18.4182 4.09811 18.1603 3.84024C17.9024 3.58238 17.5527 3.43752 17.188 3.43752Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
    highlighted: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.01413 8.73642L2.26413 5.98642C2.20021 5.92257 2.1495 5.84675 2.11491 5.76329C2.08031 5.67983 2.0625 5.59036 2.0625 5.50002C2.0625 5.40967 2.08031 5.32021 2.11491 5.23674C2.1495 5.15328 2.20021 5.07746 2.26413 5.01361L5.01413 2.26361C5.14314 2.13461 5.3181 2.06213 5.50054 2.06213C5.68298 2.06213 5.85794 2.13461 5.98695 2.26361C6.11595 2.39261 6.18842 2.56758 6.18842 2.75002C6.18842 2.93245 6.11595 3.10742 5.98695 3.23642L3.72249 5.50002L5.98695 7.76361C6.11595 7.89261 6.18842 8.06758 6.18842 8.25002C6.18842 8.43245 6.11595 8.60742 5.98695 8.73642C5.85794 8.86543 5.68298 8.9379 5.50054 8.9379C5.3181 8.9379 5.14314 8.86543 5.01413 8.73642ZM8.45163 8.73642C8.51548 8.80034 8.59131 8.85105 8.67477 8.88565C8.75823 8.92025 8.84769 8.93806 8.93804 8.93806C9.02839 8.93806 9.11785 8.92025 9.20131 8.88565C9.28477 8.85105 9.3606 8.80034 9.42445 8.73642L12.1744 5.98642C12.2384 5.92257 12.2891 5.84675 12.3237 5.76329C12.3583 5.67983 12.3761 5.59036 12.3761 5.50002C12.3761 5.40967 12.3583 5.32021 12.3237 5.23674C12.2891 5.15328 12.2384 5.07746 12.1744 5.01361L9.42445 2.26361C9.29544 2.13461 9.12048 2.06213 8.93804 2.06213C8.7556 2.06213 8.58064 2.13461 8.45163 2.26361C8.32263 2.39261 8.25016 2.56758 8.25016 2.75002C8.25016 2.93245 8.32263 3.10742 8.45163 3.23642L10.7161 5.50002L8.45163 7.76361C8.38771 7.82746 8.337 7.90328 8.30241 7.98674C8.26781 8.07021 8.25 8.15967 8.25 8.25002C8.25 8.34036 8.26781 8.42983 8.30241 8.51329C8.337 8.59675 8.38771 8.67257 8.45163 8.73642ZM17.188 3.43752H15.1255C14.9432 3.43752 14.7683 3.50995 14.6394 3.63888C14.5105 3.76781 14.438 3.94268 14.438 4.12502C14.438 4.30735 14.5105 4.48222 14.6394 4.61115C14.7683 4.74008 14.9432 4.81252 15.1255 4.81252H17.188V17.1875H4.81304V11.6875C4.81304 11.5052 4.74061 11.3303 4.61168 11.2014C4.48275 11.0724 4.30788 11 4.12554 11C3.9432 11 3.76834 11.0724 3.63941 11.2014C3.51047 11.3303 3.43804 11.5052 3.43804 11.6875V17.1875C3.43804 17.5522 3.58291 17.9019 3.84077 18.1598C4.09863 18.4177 4.44837 18.5625 4.81304 18.5625H17.188C17.5527 18.5625 17.9024 18.4177 18.1603 18.1598C18.4182 17.9019 18.563 17.5522 18.563 17.1875V4.81252C18.563 4.44784 18.4182 4.09811 18.1603 3.84024C17.9024 3.58238 17.5527 3.43752 17.188 3.43752Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
  },
  {
    name: "DMARC Generator",
    path: "/Accounts/dmarc-generator",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#868686"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-terminal"
      >
        <polyline points="4 17 10 11 4 5"></polyline>
        <line x1="12" y1="19" x2="20" y2="19"></line>
      </svg>
    ),
    highlighted: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1C485F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-terminal"
      >
        <polyline points="4 17 10 11 4 5"></polyline>
        <line x1="12" y1="19" x2="20" y2="19"></line>
      </svg>
    ),
  },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
};

export default function Account() {
  const history = useHistory();
  const locData = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [open3, setOpen3] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [advance, setAdvance] = useState(true);
  const [connectionStatus, setConnectionStatus] = useState({
    status: true,
  });
  const [name, setName] = useState("");
  const [replyName, setReplyName] = useState("");
  const [messagePerDay, setMessagePerDay] = useState("");
  const [recordName, setRecordName] = useState("");
  const [detailsDomain, setDetailsDomain] = useState([]);
  const [cert, setCert] = useState("");
  const [diffAccName, setDiffAccName] = useState("");
  const [diffReplyMail, setDiffReplyMail] = useState("");
  const [diffReply, setDiffReply] = useState(false);
  const [rcvConfirm, setRcvConfirm] = useState(false);
  const [fixedDelay, SetFixedDelay] = useState("");
  const [senderMails, setSenderMails] = useState([]);
  const [randomDelay, setRandomDelay] = useState("");
  const [email, setEmail] = useState("");
  const [hostName, setHostName] = useState("");
  const [rcvHostName, setRcvHostName] = useState("");
  const [portNumber, setPortNumber] = useState("");
  const [rcvPortNumber, setRcvPortNumber] = useState("");
  const [selected, setSelected] = useState("Daily sending limit");
  const [type, setType] = useState("");
  const [rcvHostArr, setRcvHostArr] = useState([]);
  const [addStatus, setAddStatus] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const handleClose = () => setOpen3(false);
  const [passwordStatus, setPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  const [replyPasswordStatus, setReplyPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  useEffect(() => {
    setType("");
    setAddStatus(false);
  }, [locData.pathname]);
  const [hostNameArr, setHostNameArr] = useState([]);
  const hostNameGoogle = ["smtp.gmail.com", "smtp-relay.gmail.com"];
  const hostNameZoho = [
    "smtp.zoho.eu",
    "smtp.zoho.com",
    "smtppro.zoho.com",
    "smtp.zoho.com.cn",
    "smtppro.zoho.in",
    "smtppro.zoho.eu",
    "smtp.zoho.com.au",
    "smtp.zoho.in",
    "smtp.zoho.jp",
  ];
  const hostNameGoDaddy = [
    "smtpout.secureserver.net",
    "smtpout.asia.secureserver.net",
    "smtpout.europe.secureserver.net",
    "sxb1plzcpnl440004.prod.sxb1.secureserver.net",
  ];
  const hostNameSendGrid = ["smtp.sendgrid.net", "smtp.sendgrid.com"];
  const hostNamePrivate = ["mail.privateemail.com", "smtp.privateemail.com"];
  const hostNameQQ = [
    "smtp.qq.com",
    "smtp.exmail.qq.com",
    "hwsmtp.exmail.qq.com",
  ];
  const hostNameHostinger = [
    "smtp.hostinger.com",
    "smtp.hostinger.lt",
    "smtp.hostinger.ph",
    "smtp.hostinger.in",
    "smtp.hostinger.com.br",
  ];
  const hostNameTitan = ["smtp.titan.email", "titanium.cloudhosting.co.uk"];
  const hostNameAmazonWork = [
    "smtp.mail.us-west-2.awsapps.com",
    "smtp.mail.us-east-1.awsapps.com",
    "smtp.mail.eu-west-1.awsapps.com",
  ];
  const hostNameMail163 = [
    "smtp.qiye.163.com",
    "smtphz.qiye.163.com",
    "smtp.163.com",
    "smtp.ym.163.com",
    "smtphm.qiye.163.com",
    "hwsmtp.qiye.163.com",
    "applesmtp.163.com",
    "smtp.vip.163.com",
    "hwhzsmtp.qiye.163.com",
  ];
  const hostNameLocaWeb = ["email-ssl.com.br"];
  const hostNameIonos = [
    "smtp.ionos.com",
    "smtp.ionos.es",
    "smtp.ionos.fr",
    "smtp.exchange2019.ionos.fr",
    "smtp.ionos.it",
    "smtp.ionos.co.uk",
    "smtp.exchange2019.ionos.co.uk",
    "smtp.ionos.mx",
    "smtp.ionos.de",
  ];
  const hostNameAliyun = [
    "smtp.aliyun.com",
    "smtp.qiye.aliyun.com",
    "smtpdm.aliyun.com",
    "smtpdm-ap-southeast-1.aliyun.com",
  ];
  const hostNameAmazonSes = [
    "email-smtp.us-east-2.amazonaws.com",
    "email-smtp.us-east-1.amazonaws.com",
    "email-smtp-fips.us-east-1.amazonaws.com",
    "email-smtp.us-west-1.amazonaws.com",
    "email-smtp.us-west-2.amazonaws.com",
    "email-smtp-fips.us-west-2.amazonaws.com",
    "email-smtp.ap-south-1.amazonaws.com",
    "email-smtp.ap-northeast-3.amazonaws.com",
    "email-smtp.ap-northeast-2.amazonaws.com",
    "email-smtp.ap-southeast-1.amazonaws.com",
    "email-smtp.ap-southeast-2.amazonaws.com",
    "email-smtp.ap-northeast-1.amazonaws.com",
    "email-smtp.ca-central-1.amazonaws.com",
    "email-smtp.eu-central-1.amazonaws.com",
    "email-smtp.eu-west-1.amazonaws.com",
    "email-smtp.eu-west-2.amazonaws.com",
    "email-smtp.eu-west-3.amazonaws.com",
    "email-smtp.eu-north-1.amazonaws.com",
    "email-smtp.sa-east-1.amazonaws.com",
  ];
  const hostNameMailGun = ["smtp.mailgun.org", "smtp.eu.mailgun.org"];
  const hostNameMicrosoft = ["smtp.office365.com", "smtp.live.com"];
  const rcvHostArrGmail = ["imap.gmail.com"];
  const rcvHostArrZoho = [
    "imappro.zoho.com",
    "imap.zoho.com",
    "imappro.zoho.eu",
    "imap.zoho.eu",
    "imap.zoho.com.cn",
    "imap.zoho.in",
    "imappro.zoho.in",
    "imap.zoho.com.au",
  ];
  const rcvHostArrGoDaddy = [
    "imap.asia.secureserver.net",
    "imap.secureserver.net",
  ];

  const rcvHostArrPrivate = ["mail.privateemail.com", "imap.privateemail.com"];
  const rcvHostArrQq = [
    "imap.qq.com",
    "imap.exmail.qq.com",
    "hwimap.exmail.qq.com",
  ];
  const rcvHostArrHostinger = [
    "imap.hostinger.com",
    "imap.hostinger.lt",
    "imap.hostinger.ph",
    "imap.hostinger.in",
    "imap.hostinger.com.br",
  ];
  const rcvHostArrTitan = ["imap.titan.email", "titanium.cloudhosting.co.uk"];
  const rcvHostArrAmazonWork = [
    "imap.mail.us-east-1.awsapps.com",
    "imap.mail.eu-west-1.awsapps.com",
    "imap.mail.us-west-2.awsapps.com",
  ];
  const rcvHostArrMail163 = [
    "imap.qiye.163.com",
    "imap.vip.163.com",
    "hwhzimap.qiye.163.com",
    "imap.ym.163.com",
    "imaphz.qiye.163.com",
    "imap.163.com",
    "imaphm.qiye.163.com",
    "hwimap.qiye.163.com",
    "appleimap.163.com",
  ];
  const rcvHostArrLocaWeb = ["email-ssl.com.br"];
  const rcvHostArrIonos = [
    "imap.ionos.es",
    "imap.ionos.com",
    "imap.ionos.fr",
    "mail.ionos.com",
    "imap.ionos.co.uk",
    "exchange2019.ionos.fr",
    "imap.ionos.it",
    "exchange2019.ionos.co.uk",
    "imap.ionos.mx",
    "imap.ionos.de",
  ];

  const rcvHostArrMicrosoft = [
    "imap-mail.outlook.com",
    "outlook.office365.com",
  ];

  const portNumberArr = ["465", "587", "25"];
  const rcvPortNumberArr = ["993", "143"];
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showReplyPassword, setShowReplyPassword] = useState(false);
  const [replyPassword, setReplyPassword] = useState("");
  const [filterDefaultValue, setFilterDefaultValue] = useState("Active");
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openUnsubscribeModal, setOpenUnsubscribeModal] = useState(false);
  const [unsubscribeLink, setUnsubscribeLink] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [sendLoader, setSendLoader] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFilterMenu = () => {
    setAnchorEl(null);
  };
  const certArr = ["SSL", "TLS", "None"];

  const arrayOfObjects = [
    // {
    //   id: 1,
    //   title: "Daily sending limit",
    // },
    // {
    //   id: 2,
    //   title: "Signature",
    // },
    // {
    //   id: 3,
    //   title: "Custom tracking domain",
    // },
    {
      id: 4,
      title: "Domain health",
    },
    {
      id: 5,
      title: "Email warm-up",
    },
    // {
    //   id: 6,
    //   title: "BCC to CRM",
    // },
  ];

  function togglePassword() {
    setShowPassword(!showPassword);
  }
  function addSender() {
    setSendLoader(true);
    let senderData = {
      code: "",
      fromEmail: email,
      fromName: name,
      password: password.replace(/ /g, ""),
      port: portNumber,
      host: hostName,
      service: true, //gmail and microsof true for others false
      serviceName: "gmail", //for microsoft hotmail for others empty
      imapUsername: rcvConfirm ? replyName : name,
      imapPassword: rcvConfirm
        ? replyPassword.replace(/ /g, "")
        : password.replace(/ /g, ""),
      imapHost: rcvHostName,
      imapPort: rcvPortNumber,
      imapEmail: diffReply ? diffReplyMail : email,
      limit: messagePerDay,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/check-user-added-email/${
          userDetails && userDetails.details._id
        }`,
        senderData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        setConnectionStatus(res.data);
        if (res.data.status) {
          axios
            .post(
              `${
                BaseUrl.baseurl
              }/email-marketing/user-from-email/add-user-from-email-details/${
                userDetails && userDetails.details._id
              }`,
              senderData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                toast.success(response.data.message, {
                  autoClose: true,
                  position: "top-right",
                  duration: 3000,
                });
                getAllSendEmails();
                setAddStatus(false);
              } else {
                toast.error(response.data.message, {
                  autoClose: true,
                  position: "top-right",
                  duration: 3000,
                });
                if (res.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        } else {
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setShowToast(true);
        setSendLoader(false);
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllSendEmails();
  }, []);

  function getAllSendEmails() {
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/get-all-user-from-emails-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setSenderMails(response.data.details.AddedEmails);
        } else {
          setSenderMails([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setIsLoading(false);
      })
      .catch((err) => console.log("Error"));
  }
  function deleteAccountUser() {
    setOpen4(false);
    axios
      .delete(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/delete-user-from-email/${
          userDetails && userDetails.details._id
        }/${selectedEmail._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setShowToast(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          getAllSendEmails();
        } else {
          setShowToast(true);
          toast.error(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const trackingDomainData = [
    {
      id: 1,
      title: "Step 1",
      subject: (
        <span>
          Watch our{" "}
          <b style={{ color: "#1C485F", fontWeight: 400 }}>video tutorial</b> or
          read the <b style={{ color: "#1C485F", fontWeight: 400 }}>guide</b>{" "}
          first. There you'll find detailed steps to setting up a tracking
          domain. If you already have one, go to step 2.
        </span>
      ),
    },
    {
      id: 2,
      title: "Step 2",
      subject:
        "In your domain settings panel, add a new CNAME record snov-stream.com for your tracking domain/subdomain.",
    },
    {
      id: 3,
      title: "Step 3",
      subject:
        "Paste your new tracking domain/subdomain in the field below and verify that it's ready.",
    },
  ];

  const customTrackingDomain = () => {
    return (
      <div style={{ borderRadius: "12px", padding: "10px" }}>
        <ul style={{ padding: "0px" }}>
          {trackingDomainData.map((data) => (
            <li key={data.id}>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <span
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                  }}
                >
                  {data.title}:
                </span>
                <p
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "13px",
                    fontStyle: "normal",
                    fontWeight: 400,
                  }}
                >
                  {data.subject}
                </p>
              </div>
            </li>
          ))}
        </ul>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <p
            style={{
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            Tracking domain
          </p>
          <input
            type="text"
            style={{
              padding: "8px",
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #1C485F",
              flexGrow: 1,
              outline: "none",
            }}
            placeholder="Enter your track url"
          />
          <button
            className="bg-primary"
            style={{
              color: "#fff",
              padding: "8px 20px",
              borderRadius: "4px",
              outline: "none",
              fontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            Verify
          </button>
        </div>
      </div>
    );
  };

  const dailySendingLimit = () => {
    return (
      <div className="optionalsettingboxes">
        <div className="succesemssagecointents">
          <div className="scudcestextmsg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5 10L8.53553 13.5356L15.6058 6.46448"
                stroke="#53D86A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            2000 email per day. Fixed delay: 30sec.
          </div>
        </div>
        <div className="messageperdaybox">
          <div className="emailperdayboxtext">
            Messages per day
            <div className="emailratesubtext">
              Warm-up emails do not count towards this limit, but do count
              within your provider's limit. Be mindful of this when estimating
              necessary sending volumes.
            </div>
          </div>
          <div className="plusminusboxperday">
            <div className="plusminusinside">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.93294 18.3334C14.5163 18.3334 18.2663 14.5834 18.2663 10.0001C18.2663 5.41675 14.5163 1.66675 9.93294 1.66675C5.34961 1.66675 1.59961 5.41675 1.59961 10.0001C1.59961 14.5834 5.34961 18.3334 9.93294 18.3334Z"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.59961 10H13.2663"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              2000
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.99935 18.3334C14.5827 18.3334 18.3327 14.5834 18.3327 10.0001C18.3327 5.41675 14.5827 1.66675 9.99935 1.66675C5.41602 1.66675 1.66602 5.41675 1.66602 10.0001C1.66602 14.5834 5.41602 18.3334 9.99935 18.3334Z"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.66602 10H13.3327"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 13.3334V6.66675"
                  stroke="#868686"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="fixeddelaywholebox">
          <div className="ficxeddelayinerbox">
            <FormControlLabel
              value="Fixed"
              control={<Radio style={{ color: "#1C485F" }} />}
              label="Fixed delay between emails"
              onClick={(e) => {
                SetFixedDelay(e.target.value);
              }}
              checked={fixedDelay === "Fixed"}
            />
            <div className="fideddelaysubtext">
              Random, longer delays are better for avoiding email providers'
              spam filters as they look less automated and more humanlike.
            </div>
            <div className="plusminusboxperday">
              <div className="plusminusinside">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.93294 18.3334C14.5163 18.3334 18.2663 14.5834 18.2663 10.0001C18.2663 5.41675 14.5163 1.66675 9.93294 1.66675C5.34961 1.66675 1.59961 5.41675 1.59961 10.0001C1.59961 14.5834 5.34961 18.3334 9.93294 18.3334Z"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.59961 10H13.2663"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                2000
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.99935 18.3334C14.5827 18.3334 18.3327 14.5834 18.3327 10.0001C18.3327 5.41675 14.5827 1.66675 9.99935 1.66675C5.41602 1.66675 1.66602 5.41675 1.66602 10.0001C1.66602 14.5834 5.41602 18.3334 9.99935 18.3334Z"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.66602 10H13.3327"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 13.3334V6.66675"
                    stroke="#868686"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <FormControlLabel
              value="Random"
              control={<Radio style={{ color: "#1C485F" }} />}
              label="Random delay between emails"
              onClick={(e) => {
                setRandomDelay(e.target.value);
              }}
              checked={randomDelay === "Random"}
            />
            <div className="fromdelaytodelaybox">
              <div className="plusminusboxperday">
                <div className="plusminusinside">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.93294 18.3334C14.5163 18.3334 18.2663 14.5834 18.2663 10.0001C18.2663 5.41675 14.5163 1.66675 9.93294 1.66675C5.34961 1.66675 1.59961 5.41675 1.59961 10.0001C1.59961 14.5834 5.34961 18.3334 9.93294 18.3334Z"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.59961 10H13.2663"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  2000
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.99935 18.3334C14.5827 18.3334 18.3327 14.5834 18.3327 10.0001C18.3327 5.41675 14.5827 1.66675 9.99935 1.66675C5.41602 1.66675 1.66602 5.41675 1.66602 10.0001C1.66602 14.5834 5.41602 18.3334 9.99935 18.3334Z"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.66602 10H13.3327"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 13.3334V6.66675"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              to{" "}
              <div className="plusminusboxperday">
                <div className="plusminusinside">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.93294 18.3334C14.5163 18.3334 18.2663 14.5834 18.2663 10.0001C18.2663 5.41675 14.5163 1.66675 9.93294 1.66675C5.34961 1.66675 1.59961 5.41675 1.59961 10.0001C1.59961 14.5834 5.34961 18.3334 9.93294 18.3334Z"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.59961 10H13.2663"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  2000
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.99935 18.3334C14.5827 18.3334 18.3327 14.5834 18.3327 10.0001C18.3327 5.41675 14.5827 1.66675 9.99935 1.66675C5.41602 1.66675 1.66602 5.41675 1.66602 10.0001C1.66602 14.5834 5.41602 18.3334 9.99935 18.3334Z"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.66602 10H13.3327"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 13.3334V6.66675"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              Seconds
            </div>
          </div>
        </div>
      </div>
    );
  };

  const signatureUi = () => {
    return (
      <div style={{ padding: "12px" }}>
        <p
          style={{
            color: "#868686",
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
          }}
        >
          Add an email signature that will be shown at the end of each email.
        </p>
        <div
          style={{
            backgroundColor: "#FAFAFA",
            padding: "4px 0px",
            borderRadius: "4px",
            display: "flex",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => setOpenModal(true)}
            style={{
              border: "1px solid #1C485F",
              borderRadius: "4px",
              padding: "6px 20px",
              outline: "none",
            }}
          >
            Source code
          </button>
          <button
            onClick={() => setOpenUnsubscribeModal(true)}
            style={{
              border: "1px solid #1C485F",
              borderRadius: "4px",
              padding: "6px 16px",
              outline: "none",
            }}
          >
            Unsubscribe link
          </button>
        </div>
        <p>below will have to display editor</p>
        <p
          style={{
            color: "#868686",
            fontFamily: "Source Sans 3",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
          }}
        >
          {" "}
          A great email signature can improve email engagement.
        </p>
      </div>
    );
  };

  const [healthData, setHealthData] = useState([
    {
      id: 1,
      title: "SPF",
      status: "Inactive",
      bgHex: "#FDF2E1",
      textHex: "#D4AB3D",
      text: "issue found",
      value: [],
    },
    // {
    //   id: 2,
    //   title: "DKIM",
    //   status: "Inactive",
    //   bgHex: "#FDF2E1",
    //   textHex: "#D4AB3D",
    //   text: "issue found",
    // },
    // {
    //   id: 3,
    //   title: "DMARC",
    //   status: "Missing",
    //   bgHex: "#FFEDE8",
    //   textHex: "#FD3735",
    //   text: "Missing",
    // },
    {
      id: 4,
      title: "MX",
      status: "Active",
      bgHex: "#E9F7E9",
      textHex: "#009C35",
      text: "Valid",
      value: [],
    },
    {
      id: 5,
      title: "A-record",
      status: "",
      bgHex: "",
      textHex: "",
      text: "",
      value: [],
    },
    // {
    //   id: 6,
    //   title: "rDNS",
    //   status: "Active",
    //   bgHex: "#E9F7E9",
    //   textHex: "#009C35",
    //   text: "Valid",
    // },
  ]);
  const domainHealth = () => {
    return (
      <div style={{ padding: "12px" }}>
        <ul
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gap: "20px",
          }}
        >
          {healthData.map((data) => (
            <li
              onClick={() => {
                setOpen5(true);
                setDetailsDomain(data.value);
                setRecordName(data.title);
              }}
              key={data.id}
              style={{
                backgroundColor: "#FAFAFA",
                borderRadius: "6px",
                padding: "20px 14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                opacity: type === "new" && "0.4",
                pointerEvents: type === "new" && "none",
              }}
            >
              <div
                style={{ display: "flex", gap: "12px", alignItems: "center" }}
              >
                <p
                  style={{
                    color: "#000",
                    fontFamily: "Source Sans 3",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 700,
                  }}
                >
                  {data.title}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 16V11"
                    stroke="#292D32"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.0055 8H11.9965"
                    stroke="#292D32"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                style={{
                  backgroundColor: data.bgHex,
                  borderRadius: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "4px 12px",
                }}
              >
                <p
                  style={{
                    color: data.textHex,
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                  }}
                >
                  {data.text}
                </p>
              </div>
            </li>
          ))}
        </ul>
        <button
          onClick={() => {
            getAllDomainHealthData(email);
          }}
          className="bg-primary"
          style={{
            color: "#fff",
            fontFamily: "Source Sans 3",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            borderRadius: "4px",
            padding: "6px 12px",
            border: "1px solid #1C485F",
            outline: "none",
            margin: "8px 0px",
            opacity: type === "new" && "0.4",
            pointerEvents: type === "new" && "none",
          }}
        >
          Check health
        </button>
        <div
          style={{
            display: "flex",
            gap: "6px",
            alignItems: "center",
            margin: "0px 0px 6px 0px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M18.3333 10.0001C18.3333 14.6001 14.6 18.3334 9.99996 18.3334C5.39996 18.3334 1.66663 14.6001 1.66663 10.0001C1.66663 5.40008 5.39996 1.66675 9.99996 1.66675C14.6 1.66675 18.3333 5.40008 18.3333 10.0001Z"
              stroke="#868686"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8416 9.69165 10.2 9.69165 9.67497V6.2583"
              stroke="#868686"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {/* <p
            style={{
              color: "#868686",
              fontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            Last checked: 04 Nov 2023, 07:07 PM
          </p> */}
        </div>
      </div>
    );
  };

  const points = [
    {
      id: 1,
      point: "Prepare new mailboxes for outreach",
    },
    {
      id: 2,
      point: "Restore sender and domain reputation",
    },
    {
      id: 3,
      point: "Improve deliverability and inbox placement",
    },
    {
      id: 4,
      point: "Easy set-up, real results",
    },
  ];

  const emailWarmupUi = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "20px",
          padding: "12px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <ul>
            <p
              style={{
                color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                marginBottom: "4px",
              }}
            >
              Never land in Spam or Promotions
            </p>
            {points.map((data) => (
              <li
                key={data.id}
                style={{
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <div
                  style={{
                    height: "4px",
                    width: "4px",
                    backgroundColor: "#868686",
                    borderRadius: "100%",
                  }}
                ></div>
                {data.point}
              </li>
            ))}
          </ul>
          <button
            onClick={() => {
              history.push("/MailWarmUp");
            }}
            className="bg-primary"
            style={{
              // backgroundColor: "#1C485F",
              color: "#fff",
              padding: "8px 16px",
              borderRadius: "4px",
              outline: "none",
              fontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
              alignSelf: "flex-start",
            }}
          >
            Start Warm-up
          </button>
        </div>
        <div
          style={{
            border: "1px solid #DDD",
            borderRadius: "6px",
            padding: "12px",
            flexGrow: 1,
          }}
        >
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
      </div>
    );
  };

  const bccToCrm = () => {
    return (
      <div
        style={{ padding: "12px", display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            CRM email address
          </p>
          <p
            style={{
              color: "#1C485F",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              marginTop: "0px",
            }}
          >
            Where to find your CRM email
          </p>
        </div>
        <input
          placeholder="Enter your email address"
          type="email"
          style={{
            backgroundColor: "#FAFAFA",
            borderRadius: "6px",
            border: "1px solid #1C485F",
            padding: "8px 6px",
            flexGrow: 1,
            marginTop: "6px",
          }}
        />
      </div>
    );
  };
  function getAllDomainHealthData(Email) {
    let emailData = {
      email: Email,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/check-domain-health/${
          userDetails && userDetails.details._id
        }`,
        emailData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        console.log("eeejejejeekjekj", res.data);
        if (res.data.status) {
          res.data.details.map((val, idx) => {
            if (val.type === "A") {
              if (val.status) {
                healthData[2].status = "Active";
                healthData[2].bgHex = "#E9F7E9";
                healthData[2].textHex = "#009C35";
                healthData[2].text = "Valid";
                healthData[2].value = val.details;
              } else {
                healthData[2].status = "Missing";
                healthData[2].bgHex = "#FFEDE8";
                healthData[2].textHex = "#FD3735";
                healthData[2].text = "Missing";
              }
            }
            if (val.type === "MX") {
              if (val.status) {
                healthData[1].status = "Active";
                healthData[1].bgHex = "#E9F7E9";
                healthData[1].textHex = "#009C35";
                healthData[1].text = "Valid";
                healthData[1].value = val.details;
              } else {
                healthData[1].status = "Missing";
                healthData[1].bgHex = "#FFEDE8";
                healthData[1].textHex = "#FD3735";
                healthData[1].text = "Missing";
              }
            }
            if (val.type === "TXT") {
              if (val.status) {
                healthData[0].status = "Active";
                healthData[0].bgHex = "#E9F7E9";
                healthData[0].textHex = "#009C35";
                healthData[0].text = "Valid";
                healthData[0].value = val.details;
              } else {
                healthData[0].status = "Missing";
                healthData[0].bgHex = "#FFEDE8";
                healthData[0].textHex = "#FD3735";
                healthData[0].text = "Missing";
              }
            }
            setHealthData([...healthData]);
          });
        }
      })
      .catch((err) => console.log("Error"));
  }
  const renderOptionalSettings = () => {
    if (selected === "Signature") {
      return signatureUi();
    } else if (selected === "Custom tracking domain") {
      return customTrackingDomain();
    } else if (selected === "Domain health") {
      return domainHealth();
    } else if (selected === "Email warm-up") {
      return emailWarmupUi();
    } else {
      return bccToCrm();
    }
  };

  const renderDifferentComponent = () => {
    switch (locData.pathname) {
      case "/Accounts/apply-promo-code":
        return <ApplyPromoCode />;
      case "/Accounts/billing":
        return <Billing />;
      case "/Accounts":
        return <UpdateProfile />;
      case "/Accounts/API":
        return <ApiScreen />;
      case "/Accounts/team":
        return <MyTeam />;
      // case "/Accounts/signature-builder":
      //   return <SignatureBuilder />;
      case "/Accounts/spf-generator":
        return <SpfGenerator />;
      case "/Accounts/dmarc-generator":
        return <SpfGenerator />;
      case "/Accounts/transactions":
        return <Transactions />;
      default:
        return null;
    }
  };
  function getGmailAccountAuth() {
    window.location.href =
      "https://accounts.google.com/o/oauth2/v2/auth?scope=https://mail.google.com&access_type=offline&redirect_uri=https://app.coldsender.com/Accounts/createaccount/&response_type=code&client_id=551594902408-up2bfo57q8lnggtn6m8iqbhffqmbeavq.apps.googleusercontent.com&state=65029996127866d823e82a38";
  }
  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography
              sx={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#4B4B4B",
                fontWeight: "700",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              Source code
            </Typography>
            <textarea
              style={{
                width: "100%",
                border: "1px solid #DDD",
                borderRadius: "4px",
                outline: "none",
                resize: "none",
                padding: "4px 12px",
              }}
              placeholder="Enter here"
              cols="20"
              rows="8"
            ></textarea>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <button
                onClick={() => {
                  setOpenModal(false);
                }}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  textTransform: "none",
                  // background:"#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 26px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "6px",
                }}
                className="bg-primary"
              >
                Continue
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const muiUnsubscribeModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openUnsubscribeModal}
        onClose={() => setOpenUnsubscribeModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openUnsubscribeModal}>
          <Box sx={style}>
            <Typography
              sx={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#4B4B4B",
                fontWeight: "700",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              Unsubscribe link
            </Typography>
            <p
              style={{
                color: "#868686",
                fontFamily: "Source Sans 3",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                marginBottom: "12px",
              }}
            >
              Enter the link text. This is the text that will offer your
              recipients to unsubscribe, for example: Click here to unsubscribe.
              Snov.io will generate and add your custom unsubscribe link to it.
            </p>
            <input
              value={unsubscribeLink}
              onChange={(e) => setUnsubscribeLink(e.target.value)}
              type="text"
              placeholder="Ex:click here to unsubscribe"
              style={{
                padding: "12px",
                borderRadius: "4px",
                backgroundColor: "#FAFAFA",
                outline: "none",
                width: "100%",
                marginBottom: "12px",
                border: "1px solid #1C485F",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <button
                onClick={() => {
                  setOpenUnsubscribeModal(false);
                }}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  textTransform: "none",
                  // background:"#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 26px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "6px",
                }}
                className="bg-primary"
              >
                Continue
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };
  const divRef = useRef([]);
  const copyText = () => {
    // Ensure that the div reference is not null
    if (divRef.current) {
      // Create a range and select the text content of the div
      const range = document.createRange();
      range.selectNode(divRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      // Execute the copy command
      document.execCommand("copy");

      // Clear the selection
      window.getSelection().removeAllRanges();

      // You can also provide user feedback here, like a message or notification
      console.log("Text copied to clipboard");
    }
  };
  return (
    <div
      style={{
        height: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        borderRadius: "6px",
        overflow: "hidden",
        border: "1px solid #DDD",
      }}
    >
      <Helmet>
        <title>Accounts</title>
        <meta name="description" content="Email campaign user all warmups" />
      </Helmet>
      <div
        style={{
          display: "flex",
          backgroundColor: "#fff",
          gap: "10px",
          flexGrow: 1,
          height: "100%",
          overflowY: "scroll",
        }}
      >
        <div
          style={{
            // height: "-webkit-fill-available",
            overflowY: "scroll",
            flexShrink: 0,
            position: "sticky",
            top: 0,
          }}
        >
          {/* <div className="myaccountbox">My Account</div> */}
          <div className="myaccountboxlist">
            {sideBarData.map((val, idx) => {
              return (
                <div
                  key={idx}
                  className={`${
                    locData.pathname === val.path
                      ? "sectionhighlight"
                      : "sectionboxofaccnt"
                  }`}
                  onClick={() => {
                    history.push(`${val.path}`);
                  }}
                >
                  <div style={{ display: "flex", gap: "10px" }}>
                    <>
                      {locData.pathname === val.path
                        ? val.highlighted
                        : val.svg}
                      {val.name}
                    </>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{ flexGrow: 1 }}>{renderDifferentComponent()}</div>
      </div>
      {open3 && (
        <Modal
          open={open3}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="modalPopup2"
            style={{
              width: window.innerWidth / 1.9,
              height: "100vh",
              overflowY: "scroll",
              paddingBottom: "60px",
            }}
          >
            <div className="emailboxx">Add email account</div>
            <div className="addnewaccoiuntcss">
              <div
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName("smtp.gmail.com");
                  setHostNameArr(hostNameGoogle);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrGmail);
                  setRcvHostName(rcvHostArrGmail[0]);
                  setRcvPortNumber("993");
                  setMessagePerDay(200);
                }}
                className="newemailbox"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="46"
                    viewBox="0 0 45 46"
                    fill="none"
                  >
                    <path
                      d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
                      fill="#EA4435"
                    />
                    <path
                      d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
                      fill="#00AC47"
                    />
                    <path
                      d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
                      fill="#FFBA00"
                    />
                    <path
                      d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
                      fill="#C52528"
                    />
                  </svg>
                </div>
                <div className="addacnttypename">Gmail (SMTP)</div>
              </div>
              {/* <div
                onClick={() => {
                getGmailAccountAuth()
                }}
                className="newemailbox"
              >
                <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="46"
                  viewBox="0 0 45 46"
                  fill="none"
                >
                  <path
                    d="M23.3151 27.8295L5.46978 16.4731C4.54721 15.863 3.90114 14.9149 3.67071 13.8331C3.44028 12.7513 3.64391 11.6223 4.23776 10.6892C4.8316 9.75603 5.76816 9.09344 6.84575 8.84408C7.92335 8.59471 9.05577 8.77851 9.99917 9.3559L23.0914 17.687L34.8463 9.45828C35.7635 8.8368 36.8882 8.60101 37.9777 8.80185C39.0673 9.00269 40.034 9.62403 40.6693 10.5317C41.3045 11.4393 41.5572 12.5604 41.3729 13.6528C41.1885 14.7452 40.5818 15.7213 39.6838 16.3701L23.3151 27.8295Z"
                    fill="#EA4435"
                  />
                  <path
                    d="M38.6719 38.2263H33.0469V12.9138C33.0469 11.7949 33.4913 10.7219 34.2825 9.93071C35.0737 9.13954 36.1467 8.69507 37.2656 8.69507C38.3845 8.69507 39.4576 9.13954 40.2487 9.93071C41.0399 10.7219 41.4844 11.7949 41.4844 12.9138V35.4138C41.4844 36.1597 41.1881 36.8751 40.6606 37.4026C40.1332 37.93 39.4178 38.2263 38.6719 38.2263Z"
                    fill="#00AC47"
                  />
                  <path
                    d="M41.4234 12.303C41.411 12.2186 41.412 12.1324 41.3944 12.0482C41.3674 11.9191 41.3172 11.7999 41.2787 11.6753C41.2413 11.5327 41.1963 11.3922 41.1439 11.2544C41.1158 11.1876 41.0725 11.1289 41.0406 11.064C40.9531 10.8765 40.8518 10.6958 40.7377 10.5233C40.6814 10.4416 40.6111 10.3719 40.549 10.2946C40.4423 10.154 40.327 10.0202 40.2037 9.89396C40.1102 9.80297 40.0036 9.7269 39.9019 9.64491C39.7939 9.55226 39.6812 9.46511 39.5644 9.38377C39.4529 9.31093 39.3309 9.25482 39.2129 9.19266C39.0886 9.12783 38.9668 9.05724 38.8374 9.00549C38.7124 8.95515 38.5791 8.92308 38.4484 8.88469C38.3178 8.8463 38.1879 8.80032 38.0537 8.77543C37.8875 8.74873 37.7199 8.73183 37.5517 8.7248C37.4449 8.71735 37.3392 8.69865 37.232 8.69949C37.0331 8.70529 36.8348 8.72526 36.6387 8.75926C36.5596 8.77107 36.4798 8.77008 36.4012 8.7864C36.1359 8.86747 35.8712 8.95092 35.6074 9.03671C35.535 9.06765 35.4715 9.11363 35.4014 9.14851C34.6873 9.48173 34.0849 10.0146 33.6672 10.6829C33.2495 11.3511 33.0342 12.126 33.0475 12.9139V21.0167L39.6849 16.37C40.3368 15.9326 40.8478 15.3156 41.1563 14.5937C41.4647 13.8719 41.5578 13.0764 41.4234 12.303Z"
                    fill="#FFBA00"
                  />
                  <path
                    d="M7.73438 8.69507C8.85326 8.69507 9.92631 9.13954 10.7175 9.93071C11.5087 10.7219 11.9531 11.7949 11.9531 12.9138V38.2263H6.32812C5.5822 38.2263 4.86683 37.93 4.33939 37.4026C3.81194 36.8751 3.51563 36.1597 3.51562 35.4138V12.9138C3.51563 11.7949 3.9601 10.7219 4.75127 9.93071C5.54244 9.13954 6.61549 8.69507 7.73438 8.69507Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M3.5793 12.303C3.59167 12.2186 3.59069 12.1324 3.60827 12.0482C3.63527 11.9191 3.68547 11.7999 3.724 11.6753C3.76135 11.5327 3.80632 11.3923 3.85872 11.2545C3.88684 11.1877 3.93016 11.1291 3.96222 11.0641C4.04966 10.8766 4.15091 10.6958 4.26513 10.5233C4.32138 10.4416 4.39169 10.372 4.45384 10.2946C4.56046 10.154 4.67572 10.0202 4.79894 9.89397C4.89245 9.80298 4.99905 9.7269 5.10086 9.64492C5.20888 9.55224 5.32153 9.46508 5.43836 9.38378C5.54988 9.31094 5.67194 9.25483 5.78992 9.19267C5.91185 9.1237 6.03716 9.06091 6.16539 9.00451C6.29055 8.95417 6.42386 8.92211 6.55436 8.88372C6.68486 8.84533 6.81494 8.79934 6.94909 8.77445C7.1153 8.74776 7.28294 8.73086 7.45113 8.72383C7.558 8.71637 7.66361 8.69767 7.77077 8.69851C7.9697 8.7043 8.16797 8.72428 8.36406 8.75828C8.44324 8.77009 8.52297 8.76911 8.60172 8.78542C8.73784 8.8201 8.87208 8.86178 9.00391 8.9103C9.13647 8.94553 9.26718 8.9874 9.39555 9.03573C9.46783 9.06667 9.53125 9.11265 9.60156 9.14753C9.78385 9.23317 9.95971 9.33186 10.1278 9.44284C10.6912 9.82969 11.1519 10.3478 11.4703 10.9526C11.7887 11.5573 11.955 12.2305 11.9551 12.9139V21.0167L5.31756 16.3703C4.66587 15.9327 4.1549 15.3158 3.84642 14.5939C3.53793 13.8721 3.44515 13.0764 3.5793 12.303Z"
                    fill="#C52528"
                  />
                </svg>
                </div>
                <div className="addacnttypename">Gmail</div>
              </div> */}
              <div
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName("smtp.office365.com");
                  setHostNameArr(hostNameMicrosoft);
                  setPortNumber("587");
                  setCert("TLS");
                  setRcvHostArr(rcvHostArrMicrosoft);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrMicrosoft[0]);
                  setMessagePerDay(500);
                }}
                className="newemailbox"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="46"
                    viewBox="0 0 32 33"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_2212_13112)">
                      <path
                        d="M17 15.9607H32V1.96069C32 1.69548 31.8946 1.44112 31.7071 1.25359C31.5196 1.06605 31.2652 0.960693 31 0.960693H17V15.9607Z"
                        fill="#4CAF50"
                      />
                      <path
                        d="M15 15.9607V0.960693H1C0.734784 0.960693 0.48043 1.06605 0.292893 1.25359C0.105357 1.44112 0 1.69548 0 1.96069L0 15.9607H15Z"
                        fill="#F44336"
                      />
                      <path
                        d="M15 17.9607H0V31.9607C0 32.2259 0.105357 32.4803 0.292893 32.6678C0.48043 32.8553 0.734784 32.9607 1 32.9607H15V17.9607Z"
                        fill="#2196F3"
                      />
                      <path
                        d="M17 17.9607V32.9607H31C31.2652 32.9607 31.5196 32.8553 31.7071 32.6678C31.8946 32.4803 32 32.2259 32 31.9607V17.9607H17Z"
                        fill="#FFC107"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2212_13112">
                        <rect
                          width="32"
                          height="32"
                          fill="white"
                          transform="translate(0 0.960693)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="addacnttypename">Microsoft</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostNameArr(hostNameZoho);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrZoho);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrZoho[0]);
                  setMessagePerDay(500);
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="86"
                    height="46"
                    viewBox="0 0 86 28"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_2212_13177)">
                      <path
                        d="M85.989 6.71143V25.2301L83.168 27.7318V9.60973L85.989 6.71143Z"
                        fill="#E79225"
                      />
                      <path
                        d="M67.4999 6.72668L64.5781 9.60973L64.7293 9.79278L83.0492 9.73176L83.2171 9.60973L85.9878 6.71143L67.4999 6.72668Z"
                        fill="#FFF16D"
                      />
                      <path
                        d="M64.5781 9.60986H83.2171V27.7472H64.5781V9.60986Z"
                        fill="url(#paint0_linear_2212_13177)"
                      />
                      <path
                        d="M80.3802 16.1388C80.0108 15.2998 79.4566 14.5371 78.7346 13.8811C78.0461 13.2405 77.2737 12.7523 76.4005 12.432C75.5441 12.1116 74.6206 11.9438 73.6131 11.9438C72.6055 11.9438 71.6652 12.1116 70.8088 12.432C69.9356 12.7523 69.1632 13.2405 68.4747 13.8811C67.7527 14.5371 67.2154 15.2998 66.8459 16.1388C66.4765 16.9777 66.3086 17.893 66.3086 18.8998C66.3086 19.8761 66.4933 20.7913 66.8627 21.6455C67.2321 22.4998 67.7695 23.2625 68.4915 23.9337C69.1632 24.5591 69.9356 25.032 70.792 25.3523C71.6484 25.6727 72.6055 25.8405 73.6298 25.8405C74.6206 25.8405 75.5441 25.6727 76.4005 25.3523C77.2569 25.032 78.0461 24.5591 78.7346 23.9337C79.4566 23.2625 80.0108 22.4998 80.3802 21.6608C80.7496 20.8218 80.9343 19.8913 80.9343 18.915C80.9343 17.893 80.7496 16.9777 80.3802 16.1388ZM76.5348 22.1184C75.8128 22.8964 74.8557 23.293 73.6131 23.293C72.3705 23.293 71.3965 22.8964 70.6745 22.1184C69.9524 21.3405 69.5998 20.2574 69.5998 18.8845C69.5998 17.4811 69.9692 16.3981 70.6745 15.6049C71.3965 14.8116 72.3537 14.4303 73.6131 14.4303C74.8557 14.4303 75.8128 14.8269 76.5348 15.6049C77.2401 16.3981 77.6095 17.4811 77.6095 18.8845C77.6095 20.2574 77.2569 21.3405 76.5348 22.1184Z"
                        fill="white"
                      />
                      <path
                        d="M62.7472 5.20142V5.29294L65.1316 21.9353L63.7379 25.4438L63.5532 25.3218L61.1016 9.36582L61.1519 9.15226L62.68 5.29294L62.7472 5.20142Z"
                        fill="#009ADA"
                      />
                      <path
                        d="M44.3951 7.52006L62.7486 5.20142L61.2038 9.19803L60.9855 9.41159L43.8242 11.6997L43.9082 8.84718L44.3951 7.52006Z"
                        fill="#91C9ED"
                      />
                      <path
                        d="M61.2028 9.198L63.7384 25.4438L45.6536 27.7472L43.2188 12.0505L44.2766 11.3031L61.2028 9.198Z"
                        fill="url(#paint1_linear_2212_13177)"
                      />
                      <path
                        d="M58.1295 12.31C58.0455 11.8066 57.8608 11.4252 57.5585 11.1659C57.3067 10.9676 57.0044 10.8608 56.6518 10.8608C56.5678 10.8608 56.4671 10.8608 56.3663 10.8761C55.8961 10.9371 55.5435 11.1354 55.3252 11.4558C55.1573 11.6846 55.0901 11.9744 55.0901 12.31C55.0901 12.432 55.1069 12.5693 55.1237 12.7066L55.7786 16.932L50.5731 17.6337L49.9182 13.4083C49.8343 12.9202 49.6496 12.5388 49.3473 12.2795C49.0954 12.0659 48.7932 11.9591 48.4573 11.9591C48.3734 11.9591 48.2894 11.9591 48.2055 11.9744C47.7185 12.0354 47.3491 12.2337 47.114 12.5541C46.9461 12.7829 46.8789 13.0727 46.8789 13.4083C46.8789 13.5303 46.8957 13.6676 46.9125 13.8202L48.6924 24.8185C48.7764 25.3219 48.9611 25.7032 49.2969 25.9625C49.5488 26.1608 49.8511 26.2524 50.2205 26.2524C50.3212 26.2524 50.422 26.2524 50.5227 26.2371C50.9761 26.1761 51.312 25.9778 51.5303 25.6574C51.6814 25.4286 51.7485 25.1541 51.7485 24.8337C51.7485 24.7117 51.7318 24.5744 51.715 24.4371L50.9929 20.0897L56.1984 19.388L56.9204 23.7354C57.0044 24.2388 57.1891 24.6202 57.5082 24.8642C57.76 25.0625 58.0623 25.1693 58.4149 25.1693C58.4989 25.1693 58.5996 25.1693 58.7004 25.1541C59.1706 25.093 59.5232 24.8947 59.7415 24.5744C59.8926 24.3456 59.9766 24.071 59.9766 23.7354C59.9766 23.6134 59.9598 23.4761 59.943 23.3388L58.1295 12.31Z"
                        fill="white"
                      />
                      <path
                        d="M27.2156 0.960693L20.6836 15.0556L21.5736 21.2488L21.6239 21.2336L28.962 6.23866L28.9284 5.91832L27.35 1.159L27.2156 0.960693Z"
                        fill="#66BF6B"
                      />
                      <path
                        d="M27.2148 0.960693L28.9108 6.13188L28.9444 6.23866L45.0982 12.8132L45.1486 12.7827L43.7716 7.84035L27.2148 0.960693Z"
                        fill="#98D0A0"
                      />
                      <path
                        d="M28.9123 6.13184L45.15 12.7827L37.812 27.8996L21.5742 21.2488L28.9123 6.13184Z"
                        fill="url(#paint2_linear_2212_13177)"
                      />
                      <path
                        d="M40.2301 14.003C39.8775 13.1488 39.3905 12.4166 38.7524 11.8064C38.1143 11.1962 37.3419 10.7081 36.4352 10.3573C35.5284 10.0064 34.6216 9.83862 33.6981 9.83862H33.6477C32.7074 9.83862 31.7838 10.0369 30.877 10.403C29.9199 10.7844 29.0971 11.303 28.3919 11.9895C27.6866 12.6607 27.1157 13.4844 26.6791 14.4301C26.2425 15.3607 26.0074 16.3064 25.957 17.2369V17.5573C25.957 18.381 26.1082 19.1895 26.4272 19.9827C26.763 20.8217 27.25 21.5386 27.8881 22.1488C28.5262 22.759 29.3154 23.2471 30.2557 23.5979C31.1457 23.9488 32.0525 24.1166 32.976 24.1166H32.9928C33.9164 24.1166 34.8399 23.9335 35.7467 23.5827C36.7038 23.2013 37.5434 22.6674 38.2487 21.981C38.9539 21.3098 39.5416 20.5013 39.9782 19.5556C40.4148 18.6098 40.6499 17.6793 40.7003 16.7488V16.4742C40.7171 15.6352 40.566 14.8115 40.2301 14.003ZM36.9893 18.3963C36.3848 19.7081 35.562 20.6081 34.5713 21.0963C34.0339 21.3556 33.4798 21.4929 32.9257 21.4929C32.4387 21.4929 31.9181 21.3861 31.3976 21.1878C30.2557 20.7454 29.5505 20.0437 29.2482 19.0369C29.1475 18.7013 29.0971 18.3505 29.0971 17.9844C29.0971 17.2522 29.2986 16.4437 29.7016 15.5742C30.3229 14.2318 31.1457 13.3166 32.1364 12.8132C32.6738 12.5386 33.2279 12.4166 33.782 12.4166C34.2858 12.4166 34.7896 12.5234 35.3269 12.7217C36.4519 13.164 37.1572 13.8657 37.4595 14.8725C37.5602 15.1929 37.6106 15.5437 37.6106 15.9098C37.6106 16.6725 37.4091 17.4963 36.9893 18.3963Z"
                        fill="white"
                      />
                      <path
                        d="M19.3879 3.35571L22.041 19.4947L20.832 25.1693L20.6641 24.971L18.0781 9.38114V9.07605L19.22 3.63029L19.3879 3.35571Z"
                        fill="#760D16"
                      />
                      <path
                        d="M0.0117188 11.6998L1.27111 5.9947L19.3895 3.35571L18.1637 9.16758V9.54893L0.230013 11.8523L0.0117188 11.6998Z"
                        fill="#EF463E"
                      />
                      <path
                        d="M18.1637 9.16748L20.8336 25.1692L2.89992 27.7166L0.0117188 11.6997L18.1637 9.16748Z"
                        fill="url(#paint3_linear_2212_13177)"
                      />
                      <path
                        d="M16.234 22.6218C16.0996 22.4693 15.8981 22.3625 15.663 22.2862C15.428 22.21 15.1425 22.1794 14.7899 22.1794C14.4708 22.1794 14.1014 22.21 13.6984 22.271L8.96308 23.0032C9.01346 22.6676 9.19817 22.2405 9.51722 21.7066C9.86985 21.1117 10.4072 20.3947 11.0957 19.571C11.3307 19.2811 11.5154 19.0676 11.6498 18.915C11.7337 18.8083 11.8681 18.671 12.036 18.4727C13.1275 17.1761 13.7823 16.1235 14.051 15.2998C14.2021 14.8269 14.2861 14.354 14.3197 13.8811C14.3365 13.7439 14.3365 13.6218 14.3365 13.4998C14.3365 13.1642 14.3029 12.8286 14.2357 12.493C14.1854 12.1879 14.1014 11.9439 13.9839 11.7455C13.8663 11.5472 13.732 11.3947 13.5641 11.3032C13.3793 11.1964 13.0939 11.1506 12.7413 11.1506C12.4558 11.1506 12.1032 11.1811 11.6834 11.2422L6.20922 12.0964C5.55434 12.2032 5.05058 12.371 4.74833 12.6455C4.49645 12.8591 4.37891 13.1337 4.37891 13.4388C4.37891 13.515 4.37891 13.6066 4.3957 13.6981C4.47966 14.1252 4.71474 14.4303 5.10096 14.5828C5.33604 14.6744 5.60471 14.7201 5.94055 14.7201C6.15884 14.7201 6.41072 14.7049 6.67939 14.6591L11.2468 13.9269C11.2468 14.0032 11.2636 14.0794 11.2636 14.1405C11.2636 14.3998 11.2132 14.6591 11.1124 14.9032C10.9781 15.254 10.6423 15.7422 10.0881 16.3676C9.93701 16.5354 9.70193 16.81 9.38288 17.1608C8.14028 18.5184 7.26711 19.6778 6.72977 20.6388C6.34355 21.31 6.09168 21.9506 5.94055 22.6066C5.85659 22.9879 5.80621 23.3388 5.80621 23.6896C5.80621 23.9337 5.82301 24.1778 5.87338 24.4066C5.94055 24.7422 6.02451 25.0167 6.14205 25.2303C6.2596 25.4439 6.42751 25.6117 6.61222 25.7032C6.79693 25.7947 7.04881 25.8252 7.41823 25.8252C7.87161 25.8252 8.49291 25.7642 9.28213 25.6422L14.2525 24.8642C15.1257 24.7269 15.747 24.5286 16.0996 24.2693C16.3851 24.0557 16.5362 23.7659 16.5362 23.4303C16.5362 23.3388 16.5194 23.2472 16.5026 23.1557C16.469 22.9574 16.3851 22.7744 16.234 22.6218Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_2212_13177"
                        x1="996.452"
                        y1="35.5643"
                        x2="996.452"
                        y2="1768.58"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0.00562" stop-color="#FFE513" />
                        <stop offset="1" stop-color="#FDB924" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_2212_13177"
                        x1="135.803"
                        y1="259.5"
                        x2="1854.68"
                        y2="1794.07"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0.00562" stop-color="#008CD2" />
                        <stop offset="1" stop-color="#00649D" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_2212_13177"
                        x1="1200.41"
                        y1="610.819"
                        x2="1200.41"
                        y2="2129.12"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#26A146" />
                        <stop offset="1" stop-color="#008A52" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_2212_13177"
                        x1="910.637"
                        y1="161.419"
                        x2="1140.06"
                        y2="1746.33"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#D92231" />
                        <stop offset="1" stop-color="#BA2234" />
                      </linearGradient>
                      <clipPath id="clip0_2212_13177">
                        <rect
                          width="86"
                          height="27"
                          fill="white"
                          transform="translate(0 0.960693)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="addacnttypename">Zoho</div>
              </div>
            </div>
            <div className="addnewaccoiuntcss">
              <div
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName("smtpout.secureserver.net");
                  setHostNameArr(hostNameGoDaddy);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrGoDaddy);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrGoDaddy[0]);
                  setMessagePerDay(500);
                }}
                className="newemailbox"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="46"
                    viewBox="0 0 45 46"
                    fill="none"
                  >
                    <path
                      d="M35.8485 8.97994C32.0942 6.65555 27.1517 7.20934 22.7436 9.954C18.3493 7.20934 13.4038 6.65555 9.65406 8.97994C3.72249 12.6532 3.00135 22.1131 8.04486 30.1104C11.7624 36.0063 17.5761 39.461 22.7512 39.3973C27.9264 39.461 33.7401 36.0063 37.4576 30.1104C42.495 22.1131 41.7801 12.6532 35.8485 8.97994ZM10.7718 28.4218C9.73183 26.7881 8.94718 25.0079 8.44447 23.1418C7.99783 21.5218 7.82707 19.8393 7.9392 18.1637C8.16427 15.2082 9.37845 12.9065 11.3567 11.6821C13.3349 10.4577 15.95 10.3834 18.7351 11.4788C19.1531 11.6442 19.5666 11.8354 19.9768 12.0463C18.4292 13.4446 17.0834 15.0478 15.9776 16.8103C12.9153 21.6656 11.9814 27.0684 13.0501 31.3758C12.1979 30.4648 11.435 29.4757 10.7718 28.4218ZM37.0596 23.1403C36.5561 25.0063 35.7716 26.7862 34.7323 28.4203C34.0684 29.4757 33.3056 30.4668 32.454 31.3803C33.4093 27.5189 32.7602 22.7883 30.4176 18.3519C30.3801 18.2788 30.3277 18.2143 30.2636 18.1626C30.1995 18.1109 30.1251 18.0731 30.0452 18.0516C29.9655 18.0302 29.8821 18.0256 29.8003 18.0381C29.7186 18.0506 29.6404 18.08 29.5708 18.1243L22.2675 22.6456C22.2007 22.6869 22.143 22.7407 22.0974 22.8039C22.0519 22.8673 22.0192 22.9389 22.0016 23.0148C21.984 23.0906 21.9816 23.1691 21.9947 23.2458C22.0076 23.3225 22.0359 23.396 22.0776 23.4618L23.1493 25.1596C23.1907 25.2256 23.2449 25.2828 23.3087 25.328C23.3724 25.3732 23.4446 25.4054 23.5209 25.4229C23.5974 25.4403 23.6766 25.4428 23.7538 25.4298C23.8312 25.4169 23.9051 25.3891 23.9715 25.3479L28.7057 22.4165C28.8589 22.8718 29.0121 23.3268 29.1268 23.7821C29.5734 25.4 29.7446 27.0802 29.6336 28.754C29.4086 31.7081 28.1944 34.0096 26.2162 35.2355C25.1959 35.8537 24.0266 36.1891 22.8309 36.2066H22.6792C21.4834 36.1895 20.3141 35.8541 19.2939 35.2355C17.3143 34.0096 16.1001 31.7081 15.875 28.754C15.7636 27.0783 15.9343 25.3961 16.3803 23.7759C17.4064 20.0278 19.5276 16.6638 22.4771 14.1067C23.7491 13.0003 25.1979 12.1112 26.7643 11.4758C29.5417 10.3803 32.1615 10.4532 34.1413 11.6791C36.1209 12.905 37.3337 15.2051 37.5587 18.1607C37.6723 19.8365 37.5036 21.5193 37.0596 23.1403Z"
                      fill="#1BDBDB"
                    />
                  </svg>
                </div>
                <div className="addacnttypename">GoDaddy</div>
              </div>
              <div
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName("mail.privateemail.com");
                  setHostNameArr(hostNamePrivate);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrPrivate);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrPrivate[0]);
                  setMessagePerDay(500);
                }}
                className="newemailbox"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="46"
                    viewBox="0 0 45 46"
                    fill="none"
                  >
                    <path
                      d="M35.3593 35.6482H9.35668C7.29234 35.6482 5.625 33.9808 5.625 31.9166V15.0049C5.625 12.9405 7.29234 11.2732 9.35668 11.2732H35.3593C37.4237 11.2732 39.0909 12.9405 39.0909 15.0049V31.9166C39.0514 33.9808 37.3839 35.6482 35.3593 35.6482Z"
                      fill="#2948FF"
                    />
                    <path
                      d="M24.4421 25.8027C23.1718 26.6761 21.5046 26.6761 20.2341 25.8027L17.1773 23.6986L15.8673 25.2072L19.9562 28.9786C21.2662 30.3284 23.4099 30.3284 24.72 28.9786L28.809 25.2072L27.4989 23.6986L24.4421 25.8027ZM5.625 15.7986L15.0336 24.4529L16.2643 23.0635L5.625 15.7986ZM28.4518 23.0635L29.6426 24.4529L39.0514 15.7986L28.4518 23.0635Z"
                      fill="#103BB2"
                    />
                    <path
                      d="M29.6444 24.4521L28.8107 25.2065L37.3062 35.0517C37.6238 34.8531 37.9017 34.615 38.1398 34.3371L29.6444 24.4521ZM6.5 34.3371C6.7382 34.615 7.01609 34.8531 7.33368 35.0517L15.8292 25.2065L14.9955 24.4521L6.5 34.3371Z"
                      fill="#1943C2"
                    />
                    <path
                      d="M28.4534 23.0642L27.5005 23.6993L28.8106 25.2079L29.6444 24.4536L28.4534 23.0642ZM15.0352 24.4536L15.8688 25.2079L17.1789 23.6993L16.2658 23.0642L15.0352 24.4536Z"
                      fill="#112E85"
                    />
                    <path
                      d="M37.9794 12.3844C37.3046 11.7095 36.3915 11.3125 35.3593 11.3125H9.35668C8.32451 11.3125 7.41144 11.7095 6.73656 12.3844C6.02199 13.0592 5.625 13.9723 5.625 15.0045V15.7587L16.2643 23.0236L17.1773 23.6588L20.2341 25.7628C21.5046 26.6361 23.1718 26.6361 24.4421 25.7628L27.4989 23.6588L28.4121 23.0236L39.0514 15.7587V15.0045C39.0514 13.9723 38.6542 13.0592 37.9794 12.3844Z"
                      fill="#396AFC"
                    />
                  </svg>
                </div>
                <div className="addacnttypename">Private Email</div>
              </div>
              <div
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName("smtp.qq.com");
                  setHostNameArr(hostNameQQ);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrQq);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrQq[0]);
                  setMessagePerDay(500);
                }}
                className="newemailbox"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="46"
                    viewBox="0 0 45 46"
                    fill="none"
                  >
                    <path
                      d="M18.1297 9.13508C19.8267 8.58634 21.6407 8.4339 23.4192 8.46439C23.4064 8.64985 23.3835 9.02329 23.3708 9.2113C20.9462 9.57458 18.725 10.8524 17.0789 12.6562C16.28 13.1465 15.9111 14.0509 15.2852 14.7165C14.5473 16.3678 13.8604 18.0597 13.6187 19.8659C13.2421 22.5359 13.7103 25.247 13.4151 27.9243C13.0818 28.1988 12.7536 28.4833 12.4254 28.7679C12.2779 28.8037 11.9827 28.877 11.8351 28.9151C11.1278 29.2404 10.3391 29.111 9.59111 29.06C9.20437 28.76 8.80492 28.4756 8.40294 28.1962C8.36223 27.9397 8.31898 27.6856 8.27572 27.4316C7.15625 24.7183 7.33181 21.53 8.27064 18.7838C8.40547 18.3443 8.53014 17.9022 8.6421 17.4576C9.12551 16.5202 9.66489 15.6107 10.2017 14.7012C11.222 13.6673 12.0616 12.4453 13.2701 11.6069C13.9749 10.9769 14.9341 10.7178 15.5981 10.042C15.7635 10.0217 16.0942 9.97851 16.2596 9.95818L16.7456 9.51107C16.9008 9.50091 17.2112 9.47803 17.3664 9.46534C17.6233 9.35863 17.8778 9.24913 18.1297 9.13508Z"
                      fill="#FEDE15"
                    />
                    <path
                      d="M24.7092 9.003C27.5181 8.93696 30.1208 10.324 32.2555 12.0363C34.7387 14.211 36.5833 17.1681 37.1659 20.4401C37.9648 23.9511 37.2906 27.706 35.5707 30.8456C35.2272 31.4531 34.7642 31.9815 34.2807 32.4818C34.7082 30.8177 35.2348 29.1536 35.2832 27.4236C35.25 26.1407 35.0033 24.868 34.6292 23.6434C33.1408 19.4644 29.3779 16.5327 25.3504 14.9601C24.1112 14.5664 23.0708 13.6721 22.5898 12.4552C22.6077 11.6372 22.8417 10.8547 23.1572 10.1079C23.626 9.67595 24.1474 9.30474 24.7092 9.003Z"
                      fill="#49AB30"
                    />
                    <path
                      d="M20.5408 17.6942C21.8385 16.7974 23.5711 16.9701 24.8838 17.7323C24.8585 17.839 24.8051 18.0524 24.777 18.1591C25.0747 18.2658 25.4996 18.2658 25.67 18.5935C26.3799 19.6224 26.5325 20.9103 26.5732 22.1298C27.4282 23.1461 27.9905 24.3781 28.0057 25.7219C27.5325 25.5519 27.077 25.0923 26.5657 25.181C26.2629 25.5569 26.0441 25.9891 25.7896 26.3953C26.4791 26.5096 27.0746 27.0024 26.9143 27.7619C25.4868 28.4047 23.6371 28.5725 22.3803 27.4876C21.1515 28.3794 19.541 28.3693 18.2103 27.7061C18.1391 27.0609 18.4647 26.6109 19.0702 26.4001C18.6963 25.9584 18.3782 25.4754 18.106 24.9673C17.6709 25.1782 17.2384 25.394 16.8008 25.6049C16.956 24.2508 17.5666 22.9807 18.564 22.0458C18.6148 20.5036 18.9303 18.8219 20.1975 17.7955C21.1269 17.8676 20.4474 17.6292 20.5408 17.6942Z"
                      fill="#2789B7"
                    />
                    <path
                      d="M29.2299 29.6445C30.0007 29.0424 30.9879 28.989 31.9243 29.0831C33.0284 29.5757 33.7128 30.5767 34.0104 31.7226C33.8476 32.3882 33.7713 33.1275 33.2853 33.6585C31.4713 35.7493 29.0111 37.2735 26.3191 37.9365C22.7011 38.9807 18.7372 38.4092 15.4093 36.7196C12.4275 35.1881 10.0944 32.5584 8.73828 29.5151C8.85785 29.5305 9.09701 29.5631 9.21659 29.5787C10.6159 31.3266 12.5241 32.6475 14.5952 33.4834C15.3483 33.7042 16.1141 33.8719 16.8825 34.0294C17.8849 34.1664 18.9102 34.1869 19.9126 34.0217C21.1466 33.8976 22.3424 33.5415 23.495 33.0947C25.6169 32.3222 27.4132 30.9399 29.2299 29.6445Z"
                      fill="#F80A06"
                    />
                  </svg>
                </div>
                <div className="addacnttypename">Mail QQ</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName("smtp.mailgun.org");
                  setHostNameArr(hostNameMailGun);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvPortNumber("993 ");
                  setRcvHostArr([]);
                  setMessagePerDay(300);
                }}
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="45"
                    height="46"
                    viewBox="0 0 45 46"
                    fill="none"
                  >
                    <mask
                      id="mask0_2214_13231"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="6"
                      y="7"
                      width="33"
                      height="33"
                    >
                      <path
                        d="M38.4375 7.52319H6.5625V39.3982H38.4375V7.52319Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_2214_13231)">
                      <path
                        d="M22.4998 20.7026C24.0236 20.7026 25.2585 21.9373 25.2585 23.4605C25.2585 24.9843 24.0236 26.2192 22.4998 26.2192C20.9764 26.2192 19.7415 24.9838 19.7415 23.4605C19.7415 21.9373 20.9764 20.7026 22.4998 20.7026ZM13.101 23.4605C13.101 18.2697 17.309 14.0618 22.4998 14.0618C27.6913 14.0618 31.899 18.2697 31.899 23.4605C31.899 23.8042 31.8806 24.1432 31.8446 24.4766C31.7732 25.3929 32.4456 26.0923 33.3561 26.0923C34.9011 26.0923 35.0657 24.1001 35.0657 23.4605C35.0657 16.5203 29.4399 10.8946 22.4998 10.8946C15.5596 10.8946 9.9339 16.5204 9.9339 23.4605C9.9339 30.4004 15.5596 36.0264 22.4996 36.0264C26.1853 36.0264 29.5005 34.4403 31.7993 31.913L34.3824 34.0824C31.4646 37.3441 27.2218 39.3988 22.4998 39.3988C13.6978 39.3988 6.5625 32.2627 6.5625 23.4605C6.5625 14.6585 13.6978 7.52319 22.4998 7.52319C31.3022 7.52319 38.4375 14.6585 38.4375 23.4607C38.4375 26.9986 36.7528 29.8717 33.3692 29.8717C31.8799 29.8717 30.9748 29.1896 30.4806 28.4279C28.8208 31.0886 25.8675 32.8601 22.4998 32.8601C17.3089 32.8601 13.101 28.6513 13.101 23.4605ZM22.4998 17.433C19.1711 17.433 16.4722 20.1314 16.4722 23.4605C16.4722 26.7896 19.1711 29.4884 22.4998 29.4884C25.8287 29.4884 28.5278 26.7896 28.5278 23.4605C28.5278 20.1314 25.8287 17.433 22.4998 17.433Z"
                        fill="#AF252A"
                      />
                    </g>
                  </svg>
                </div>
                <div className="addacnttypename">Mailgun</div>
              </div>
            </div>
            <div className="addnewaccoiuntcss">
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameHostinger[0]);
                  setHostNameArr(hostNameHostinger);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrHostinger);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrHostinger[0]);
                  setMessagePerDay(500);
                }}
              >
                <div>
                  <img loading="lazy" src={hostinger} alt="" />
                </div>

                <div className="addacnttypename">Hostinger</div>
              </div>
              <div
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameTitan[0]);
                  setHostNameArr(hostNameTitan);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrTitan);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrTitan[0]);
                  setMessagePerDay(1000);
                }}
                className="newemailbox"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="49"
                    height="46"
                    viewBox="0 0 49 46"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_4287_67271)">
                      <path
                        d="M48.6484 15.555L48.6471 15.6117C48.6278 16.0261 48.3981 16.4038 48.0356 16.611L40.1349 21.1256V37.4462C40.1349 37.9068 39.8747 38.3279 39.4626 38.5339L24.868 45.831C24.0594 46.2353 23.1079 45.6473 23.1079 44.7432V14.4724C23.1079 13.9924 23.3903 13.5572 23.8288 13.3617L46.9369 3.05749C47.7413 2.69879 48.6484 3.28749 48.6484 4.16823V15.555Z"
                        fill="black"
                      />
                      <path
                        d="M46.2168 6.04248L25.5411 15.2624V42.7768L37.7033 36.6958V20.4206L37.7046 20.3639C37.7239 19.9495 37.9536 19.5717 38.3161 19.3646L46.2168 14.8498V6.04248Z"
                        fill="white"
                      />
                      <path
                        d="M0 15.555L0.00131895 15.6117C0.02061 16.0261 0.250337 16.4038 0.612804 16.611L8.51351 21.1256V37.4462C8.51351 37.9068 8.77379 38.3279 9.18582 38.5339L23.7804 45.831C24.5891 46.2353 25.5405 45.6473 25.5405 44.7432V14.4724C25.5405 13.9924 25.2581 13.5572 24.8197 13.3617L1.71154 3.05749C0.907125 2.69879 0 3.28749 0 4.16823V15.555Z"
                        fill="black"
                      />
                      <path
                        d="M2.43164 6.04199L23.1073 15.2616V42.7751L10.9452 36.6942V20.4196L10.9438 20.3629C10.9245 19.9485 10.6948 19.5708 10.3323 19.3637L2.43164 14.849V6.04199Z"
                        fill="white"
                      />
                      <path
                        d="M2.43514 0.960938H46.2131C48.8399 0.960938 49.6013 4.54915 47.2009 5.61615L25.3119 15.3459C24.683 15.6254 23.9652 15.6254 23.3363 15.3459L1.44737 5.61615C-0.953075 4.54915 -0.191711 0.960938 2.43514 0.960938Z"
                        fill="black"
                      />
                      <path
                        d="M2.43495 3.39355L24.3239 13.1233L46.2129 3.39355H2.43495Z"
                        fill="white"
                      />
                      <path
                        d="M-0.00015834 3.39355H0.486328V4.36653H-0.00015834V3.39355Z"
                        fill="black"
                      />
                      <path
                        d="M48.162 3.39355H48.6484V4.36653H48.162V3.39355Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4287_67271">
                        <rect
                          width="48.6486"
                          height="45"
                          fill="white"
                          transform="translate(0 0.960938)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="addacnttypename">Titan</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameAmazonWork[0]);
                  setHostNameArr(hostNameAmazonWork);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrAmazonWork);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrAmazonWork[0]);
                  setMessagePerDay(200);
                }}
              >
                <div>
                  <img src={amazon1} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Amazon Workmail</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameMail163[0]);
                  setHostNameArr(hostNameMail163);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrMail163);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrMail163[0]);
                  setMessagePerDay(200);
                }}
              >
                <div>
                  <img src={s163} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Mail 163</div>
              </div>
            </div>
            <div className="addnewaccoiuntcss">
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameAmazonSes[0]);
                  setHostNameArr(hostNameAmazonSes);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr([]);
                  setRcvPortNumber("993");
                  setMessagePerDay(200);
                }}
              >
                <div>
                  <img src={ses1} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Amazon SES</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameAliyun[0]);
                  setHostNameArr(hostNameAliyun);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr([]);
                  setRcvPortNumber("993");
                  setMessagePerDay(2000);
                }}
              >
                <div>
                  <img src={alliyon} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Aliyun</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameLocaWeb[0]);
                  setHostNameArr(hostNameLocaWeb);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrLocaWeb);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrLocaWeb[0]);
                  setMessagePerDay(500);
                }}
              >
                <div>
                  <img src={locaWeb} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Locaweb</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameIonos[0]);
                  setHostNameArr(hostNameIonos);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr(rcvHostArrIonos);
                  setRcvPortNumber("993");
                  setRcvHostName(rcvHostArrIonos[0]);
                  setMessagePerDay(200);
                }}
              >
                <div>
                  <img src={ionos1} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Ionos</div>
              </div>
            </div>
            <div className="addnewaccoiuntcss">
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostName(hostNameSendGrid[0]);
                  setHostNameArr(hostNameSendGrid);
                  setPortNumber("465");
                  setCert("SSL");
                  setRcvHostArr([]);
                  setRcvPortNumber("993");
                  setRcvHostName([]);
                  setMessagePerDay(200);
                }}
              >
                <div>
                  <img src={sendGrid} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Sendgrid</div>
              </div>
              <div
                className="newemailbox"
                onClick={() => {
                  setOpen3(false);
                  setAddStatus(true);
                  setHostNameArr([]);
                  setRcvHostArr([]);
                  setPortNumber("465");
                  setCert("SSL");
                  setMessagePerDay(200);
                  setRcvPortNumber("993");
                }}
              >
                <div>
                  <img src={send2} alt="" loading="lazy" />
                </div>

                <div className="addacnttypename">Others</div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {open4 && (
        <Modal
          open={open4}
          onClose={() => {
            setOpen4(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete">
            <div className="modaltext">Confirm Delete</div>
            <div className="modalsubtext">
              Are you sure you want to delete this Account?
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen4(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  deleteAccountUser();
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </Modal>
      )}
      {openModal && muiModal()}
      {openUnsubscribeModal && muiUnsubscribeModal()}
      <Modal
        open={open5}
        onClose={() => {
          setOpen5(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopup" style={{ width: "38vw", left: "34%" }}>
          <div className="modaltext">{recordName}</div>
          <div className="modalsubtext">
            {recordName === "SPF"
              ? "SPF record prevents spammers from sending emails from your domain"
              : recordName === "MX"
              ? "MX record specifies which email server is responsible for handling emails for your domain. It is required for delivering emails."
              : "A record helps computers find the server hosting your domain. This is necessary for your email to be delivered."}
          </div>

          <div className="modalmoxtextlabel">
            Your domain’s {recordName} record:
          </div>
          <div className="boxofdomian">
            <div style={{ float: "right" }}>
              <ContentCopyIcon
                onClick={copyText}
                style={{ cursor: "pointer" }}
              />
            </div>
            {detailsDomain.map((val, idx) => {
              return (
                <div ref={divRef} className="modalmoxtextlabel">
                  {recordName === "MX"
                    ? `Priority:${val.priority} host:${val.exchange}`
                    : recordName === "SPF"
                    ? `Record:${val[0]}`
                    : `Ip:${val}`}
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
      {showToast && <ToastContainer />}
    </div>
  );
}
